import styled, { StyledProps } from 'styled-components/macro';

export type Props = StyledProps<{
  active: boolean;
}>;

export const Container = styled.div`
  position: absolute;
  min-width: 214px;
  background: #FAFAFA;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  top: 42px;
  width: 100%;
`

export const Search = styled.div`
  padding: 15px 15px 10px 15px;
`

export const List = styled.div`
  padding: 0 10px 10px 10px;
  overflow-y: auto;
  overflow-x: hidden;
`

export const ListItem = styled.div<Props>`
  color: ${(props) => props.active ? '#003667' : '#0A1128'};
  font-weight: ${(props) => props.active ? '600' : '400'};
  font-size: 13px;
  font-family: 'Inter';
  height: 32px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  transition: .2s;
  padding: 0 10px;
  line-height: 32px;

  &:hover {
    background: #EBEBEB;
  }
`
